(function ($) {
    var $healthQuestions = $('.health-questions');
    var $healthQuestionsForm = $('form.health-questions-form');

    /**
     * Gesundheitsfrage öffnen
     */
    var activateHealthQuestion = function (formName) {
        $healthQuestionsForm.removeClass('active');
        var id = formName + '-form';
        var $form = $('#' + id);

        if ($form.length) {
            $healthQuestions.removeClass('closed');
            $form.addClass('active');
            $healthQuestions.find('.info .content').fadeOut(250)
            $form.find('input[type="number"]').focus();
        } else {
            $healthQuestions.addClass('closed');
        }
    };
    $(document).on('click', '.health-question-link', function (e) {
        e.preventDefault();
        activateHealthQuestion($(this).data('target'));
    });
    $(document).on('click', 'a[href="#health-questions"]', function () {
        if ($healthQuestions.hasClass('closed')) {
            $healthQuestions.find('.info .todo a').first().click();
        }
    });

    /**
     * AJAX-Funktionalität für die Formulare
     */
    var updateHealthQuestions = function (e) {
        e.preventDefault();

        var $submitButton = $(this);
        var $form = $(this).parents('form');
        var url = '/zahnzusatzversicherungen';
        if ($form.attr('action')) {
            url = $form.attr('action');
        }
        var data = $form.serializeArray();
        data.push({
            name: $submitButton.attr('name'),
            value: $submitButton.val()
        });

        $form.find('input[type="submit"]').removeClass('active');
        $submitButton.addClass('active');

        $healthQuestions.addClass('loading');
        $.post(url, data, function (data) {
            $healthQuestions.removeClass('loading');

            if (data.hasOwnProperty('progressValue')) {
                var progressValue = data.progressValue;
                $healthQuestions.find('.progress-wrapper .value').html(progressValue + '%');
                $healthQuestions.find('progress').attr('value', progressValue);

                if (progressValue === 100) {
                    $healthQuestions.addClass('finished');
                } else {
                    $healthQuestions.removeClass('finished');
                }

                if (progressValue > 0) {
                    $('h1').slideUp();
                }
            }

            if (data.hasOwnProperty('nextQuestion')) {
                activateHealthQuestion(data.nextQuestion);
            }

            if (data.hasOwnProperty('infoHtml')) {
                $healthQuestions.find('.info .content').html(data.infoHtml);
            }

            if (data.hasOwnProperty('infotext')) {
                $healthQuestions.find('.infotext').html(data.infotext);
            }

            if (data.hasOwnProperty('teethWithDentures')) {
                var teethWithDentures = data.teethWithDentures;
                var $select = $healthQuestions.find('select[name="teethWithDenturesOlder"]');
                $select.find('option').each(function () {
                    var value = parseInt(this.value);
                    if (teethWithDentures !== null && value > teethWithDentures) {
                        $(this).hide();
                        $(this).attr('disabled', 'disabled');
                    } else {
                        $(this).show();
                        $(this).removeAttr('disabled');
                    }
                });
            }

            if (data.hasOwnProperty('insureMissingTeeth') && data.insureMissingTeeth === null) {
                $($healthQuestions.find('input[name=insureMissingTeeth]').removeClass('active'));
            }

            if (data.hasOwnProperty('parodontoseAktuell') && data.parodontoseAktuell === null) {
                $($healthQuestions.find('input[name=parodontoseAktuell]').removeClass('active'));
            }

            if (
                data.hasOwnProperty('laufendeBehandlungNurKontrolle')
                && data.laufendeBehandlungNurKontrolle === null
            ) {
                $($healthQuestions.find('input[name=laufendeBehandlungNurKontrolle]').removeClass('active'));
            }

            if (
                data.hasOwnProperty('instantDentureRefund')
                && data.instantDentureRefund === null
            ) {
                $($healthQuestions.find('input[name=instantDentureRefund]').removeClass('active'));
            }

            if (
                data.hasOwnProperty('laufendeBehandlungNurKunststofffuellungen')
                && data.laufendeBehandlungNurKunststofffuellungen === null
            ) {
                $($healthQuestions.find('input[name=laufendeBehandlungNurKunststofffuellungen]').removeClass('active'));
            }

            window.updateListing();
        }, "json")
            .fail(function () {
                alert('Es ist ein unbekannter Fehler aufgetreten.');
                $healthQuestions.removeClass('loading');
            });
    };
    $healthQuestionsForm.find('input[type="submit"]').on('click', updateHealthQuestions);

    /**
     * Funktion für den Schließen-Button
     */
    $(document).on('click', '.health-questions .close', function (e) {
        e.preventDefault();
        activateHealthQuestion(null);
    });

    /**
     * Funktion für den Öffnen-Button
     */
    $(document).on('click', '.health-questions .open', function (e) {
        e.preventDefault();
        $healthQuestions.find('.info .todo a').first().click();
    });

    /**
     * Nächste Gesundheitsfrage öffnen
     */
    var openNextHealthQuestion = function () {
        var $currentHealthQuestion = $healthQuestions.find('form.health-questions-form.active');
        var questionName = $currentHealthQuestion.find('input[name="question"]').val();
        var $currentLi = $healthQuestions.find('.info li[data-name="' + questionName + '"]');

        if ($currentLi.next('li').length) {
            $currentLi.next('li').find('a').click();
        } else {
            $healthQuestions.find('.info li a').first().click();
        }
    };
    $(document).on('click', '.health-questions button.next', openNextHealthQuestion);
    $(document).on('click', '.health-questions button.skip', openNextHealthQuestion);

    /**
     * Vorherige Gesundheitsfrage öffnen
     */
    var openPrevHealthQuestion = function () {
        var $currentHealthQuestion = $healthQuestions.find('form.health-questions-form.active');
        var questionName = $currentHealthQuestion.find('input[name="question"]').val();
        var $currentLi = $healthQuestions.find('.info li[data-name="' + questionName + '"]');

        if ($currentLi.prev('li').length) {
            $currentLi.prev('li').find('a').click();
        } else {
            $healthQuestions.find('.info li a').last().click();
        }
    };
    $(document).on('click', '.health-questions button.prev', openPrevHealthQuestion);

    /**
     * InfoPopup einblenden/ausblenden
     */
    $healthQuestions.find('.info').hoverIntent({
        over: function() {
            $(this).find('.content').fadeIn(250);
        },
        out: function() {
            $(this).find('.content').fadeOut(250);
        },
        timeout: 500,
        interval: 0,
        sensitivity: 1
    });
    $healthQuestions.find('.info .handle').click(function () {
        $healthQuestions.find('.info .content').fadeToggle(250);
    });
}(jQuery));
